import { useState, useEffect } from 'react'
import s from './DueToday.scss'
import { AllDashboardComponent } from '../DictionaryDashboard'
import { FaExclamation } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { makeReportsGetRequest } from 'utils/api'

const DueToday = ({ type, layoutLocked }) => {
  const navigate = useNavigate()
  const [deals, setDeals] = useState({
    bids: [],
    followUps: []
  })

  useEffect(() => {
    ;(async () => {
      const response = await makeReportsGetRequest('/v1/deals/dueToday')
      setDeals(response)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getRow = (deal, type) => (
    <li key={deal.id} className={s.deal}>
      {type} {deal.name} {deal.dealManager}
    </li>
  )

  return (
    <>
      <div onClick={layoutLocked ? () => navigate('/calendar') : null} className={s.wrapper}>
        <>
          <FaExclamation className={s.icon} />
          <div className={s.dealsWrapper}>
            <h6>{AllDashboardComponent[type].label}</h6>
            {![...deals.bids, ...deals.followUps].length ? (
              <p>There are no opportunities with bids or follow-up due today</p>
            ) : (
              <ul>
                {deals.bids.map(deal => getRow(deal, 'BID'))}
                {deals.followUps.map(deal => getRow(deal, 'FLW'))}
              </ul>
            )}
          </div>
          <div className={s.action}>{'Go to Calendar'.toUpperCase()}</div>
        </>
      </div>
    </>
  )
}

export default DueToday
